// One shared IndexedDB opener for the whole portal.
// Previously three modules opened the same database with different version
// numbers (drafts v2, stage2 v2, stage3 v3). After a visit to Stage 3 the
// database sat at version 3, and every version-2 open then failed with
// VersionError — the "Local save failed" banner. Opening WITHOUT a version
// (current version, whatever it is) and creating any missing object store
// with a +1 upgrade removes the race for good.
const DATABASE_NAME = "wsi-student-support";
const REQUIRED_STORES = ["drafts", "stage2", "stage3"];

function ensureStores(database: IDBDatabase) {
  for (const name of REQUIRED_STORES) {
    if (!database.objectStoreNames.contains(name)) {
      database.createObjectStore(name);
    }
  }
}

export function openWsiDatabase(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DATABASE_NAME);
    request.onupgradeneeded = () => ensureStores(request.result);
    request.onsuccess = () => {
      const database = request.result;
      const missing = REQUIRED_STORES.some(
        (name) => !database.objectStoreNames.contains(name),
      );
      if (!missing) {
        resolve(database);
        return;
      }
      const nextVersion = database.version + 1;
      database.close();
      const upgrade = indexedDB.open(DATABASE_NAME, nextVersion);
      upgrade.onupgradeneeded = () => ensureStores(upgrade.result);
      upgrade.onsuccess = () => resolve(upgrade.result);
      upgrade.onerror = () => reject(upgrade.error);
    };
    request.onerror = () => reject(request.error);
  });
}
